import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { dialogActions } from '@/redux';
import { useDispatch } from 'react-redux';
import { useSelector } from '@redux/store/store';

const BaseDialog = () => {
  const { isOpen, content, handleClose } = useSelector((state) => state.dialog);
  const { dialogTitle, dialogContentText, disagreeButtonText, agreeButtonText } = content;

  const dispatch = useDispatch();
  // guards against a second click during the close transition, which would call handleClose twice
  const isHandledRef = React.useRef(false);

  React.useEffect(() => {
    if (isOpen) isHandledRef.current = false;
  }, [isOpen]);

  const handleResult = async (result: boolean) => {
    if (isHandledRef.current) return;
    isHandledRef.current = true;
    handleClose?.(result, null);
    dispatch(dialogActions.closeDialog());
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => handleResult(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        {dialogTitle && <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>}
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {dialogContentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {disagreeButtonText && (
            <Button
              variant='outlined'
              onClick={() => handleResult(false)}
              disabled={!isOpen}
            >
              {disagreeButtonText}
            </Button>
          )}
          <Button
            variant='contained'
            onClick={() => handleResult(true)}
            disabled={!isOpen}
            autoFocus
          >
            {agreeButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BaseDialog;
